//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/radical/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveRadical: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/radical/edit/save", vo, successCallback, failureCallback);
    },
};

export default EditService;
